<template>
	<v-card outlined
		style="width:100%; height:100%; object-fit: fill; background: rgb(40 20 20); padding: 80px;" 
		
	>
		<v-card-title
			class="pa-0 caption vue-draggable-handle"					
		>
		</v-card-title>
		 <v-menu
      v-model="showMenu"
      absolute
      offset-y
      style="max-width: 600px"
    >
    <!--           height="300"
          width="600" -->
      <template v-slot:activator="{ on, attrs }">
        <v-img
          class="portrait"
          src="@/assets/video.png"
          v-bind="attrs"
          v-on="on"
        ></v-img>
      </template>
    

      <v-list
      	:max-height="'400px'"
      	color="dark"
      >
        <v-list-item
          v-for="(item, index) of list"
          :key="index"
          dark
          color="secondary"
          @click = "select_item(item)"
        >
          <v-list-item-title color="secondary">{{ item.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
  	
    </v-menu>
		<!-- <v-img			
			src=""			
		></v-img> -->
	</v-card>
</template>
<script>
	export default{
		name: 'blank_component',
		props:[
			'layout',
			'layout_id',
		],
		data: () => ({
			info: {},
			showMenu: false,
			list: [
		        // { title: 'Click Me' },
		        // { title: 'Click Me' },
		        // { title: 'Click Me' },
		        // { title: 'Click Me 2' },
		      ],

		}), // data
		created(){
			this.get_local()
		}, // created 

		methods: {
			render_component(){

			}, 

			get_local(){
				if (localStorage.getItem('list_devices')) {
					this.list = JSON.parse(localStorage.getItem('list_devices'));
				}
			}, // get local

			select_item(item){
				let id = null, device_id = null;
				if (this.layout_id && item) {
					id 			= this.layout_id;
					device_id 	= item.deviceId; 
					this.$emit('select_device',{
						ID 		: id,
						device 	: device_id 
					})
				}
			}, // select item	
		}, // methods

		mounted(){

		}
	}; 
</script>